(function () {
  'use strict';

  var CLAIMED_KEY = 'tude_15_discount_claimed';
  var DISMISSED_KEY = 'tude_15_popup_dismissed_session';
  var PENDING_KEY = 'tude_15_submission_pending';
  var root = document.querySelector('[data-tude-welcome-popup]');

  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var backdrop = root.querySelector('[data-tude-popup-backdrop]');
  var dialog = root.querySelector('[data-tude-popup-dialog]');
  var closeButton = root.querySelector('[data-tude-popup-close]');
  var continueButton = root.querySelector('[data-tude-popup-continue]');
  var launcher = document.querySelector('[data-tude-popup-launcher]');
  var launcherOpenButton = document.querySelector('[data-tude-popup-launcher-open]');
  var launcherDismissButton = document.querySelector('[data-tude-popup-launcher-dismiss]');
  var form = root.querySelector('#Tude15PopupForm');
  var formState = root.querySelector('[data-tude-popup-form-state]');
  var successState = root.querySelector('[data-tude-popup-success-state]');
  var nameInput = root.querySelector('[data-tude-popup-name]');
  var firstNameInput = root.querySelector('[data-tude-popup-first-name]');
  var lastNameInput = root.querySelector('[data-tude-popup-last-name]');
  var countryCodeSelect = root.querySelector('[data-tude-popup-country-code]');
  var phoneNationalInput = root.querySelector('[data-tude-popup-phone-national]');
  var phoneInput = root.querySelector('[data-tude-popup-phone]');
  var emailInput = root.querySelector('[data-tude-popup-email]');
  var errorMessage = root.querySelector('[data-tude-popup-error]');
  var serverSuccess = root.querySelector('[data-tude-popup-server-success]');
  var serverError = root.querySelector('[data-tude-popup-server-error]');
  var previousFocus = null;
  var previousBodyPaddingRight = '';
  var timer = null;
  var isOpen = false;
  var isClosing = false;

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; the form still works.
    }
  }

  function storageRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; the form still works.
    }
  }

  function isClaimed() {
    return storageGet(window.localStorage, CLAIMED_KEY) === 'true';
  }

  function isDismissedForSession() {
    return storageGet(window.sessionStorage, DISMISSED_KEY) === 'true';
  }

  function isSubmissionPending() {
    return storageGet(window.sessionStorage, PENDING_KEY) === 'true';
  }

  function hasShopifySuccessRedirect() {
    var params = new URLSearchParams(window.location.search);
    var postedSuccessfully = params.get('customer_posted') === 'true'
      || params.get('contact_posted') === 'true';

    return postedSuccessfully && isSubmissionPending();
  }

  function focusableElements() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return !element.hidden && element.offsetParent !== null;
    });
  }

  function lockScroll() {
    var scrollbarGap = window.innerWidth - document.documentElement.clientWidth;
    previousBodyPaddingRight = document.body.style.paddingRight;
    if (scrollbarGap > 0) document.body.style.paddingRight = scrollbarGap + 'px';
    document.documentElement.classList.add('tude-popup-open');
    document.body.classList.add('tude-popup-open');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('tude-popup-open');
    document.body.classList.remove('tude-popup-open');
    document.body.style.paddingRight = previousBodyPaddingRight;
  }

  function hideLauncher() {
    if (!launcher) return;
    launcher.classList.remove('is-visible');
    launcher.hidden = true;
  }

  function showLauncher(shouldFocus) {
    if (!launcher || isClaimed()) return;
    launcher.hidden = false;
    window.requestAnimationFrame(function () {
      launcher.classList.add('is-visible');
    });
    if (shouldFocus && launcherOpenButton) {
      launcherOpenButton.focus({ preventScroll: true });
    }
  }

  function openPopup(force) {
    if (isOpen || isClosing) return;
    if (!force && (isClaimed() || isDismissedForSession())) return;

    previousFocus = document.activeElement;
    hideLauncher();
    isOpen = true;
    root.hidden = false;
    lockScroll();

    window.requestAnimationFrame(function () {
      root.classList.add('is-active');
    });

    window.setTimeout(function () {
      var focusTarget = continueButton && !continueButton.closest('[hidden]')
        ? continueButton
        : dialog;
      focusTarget.focus({ preventScroll: true });
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 410);
  }

  function closePopup(collapseToLauncher) {
    if (!isOpen || isClosing) return;

    if (collapseToLauncher) {
      storageSet(window.sessionStorage, DISMISSED_KEY, 'true');
    }

    isClosing = true;
    root.classList.remove('is-active');

    window.setTimeout(function () {
      root.hidden = true;
      unlockScroll();
      isOpen = false;
      isClosing = false;

      if (collapseToLauncher) {
        showLauncher(true);
      } else if (previousFocus && typeof previousFocus.focus === 'function' && document.contains(previousFocus)) {
        previousFocus.focus({ preventScroll: true });
      }
    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 1 : 400);
  }

  function showSuccess() {
    storageRemove(window.sessionStorage, PENDING_KEY);
    storageSet(window.localStorage, CLAIMED_KEY, 'true');
    hideLauncher();
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
    if (continueButton) continueButton.focus({ preventScroll: true });
  }

  function showError() {
    if (!errorMessage) return;
    errorMessage.hidden = false;
    errorMessage.focus({ preventScroll: true });
  }

  function prepareContactFields() {
    var fullName = nameInput ? nameInput.value.trim().replace(/\s+/g, ' ') : '';
    var nameParts = fullName ? fullName.split(' ') : [];
    var rawPhone = phoneNationalInput ? phoneNationalInput.value.trim() : '';
    var countryDigits = countryCodeSelect ? countryCodeSelect.value.replace(/\D/g, '') : '';
    var nationalDigits = rawPhone.replace(/\D/g, '');

    if (nameInput) {
      nameInput.value = fullName;
      nameInput.removeAttribute('aria-invalid');
    }

    if (firstNameInput) firstNameInput.value = nameParts.shift() || '';
    if (lastNameInput) lastNameInput.value = nameParts.join(' ');

    if (rawPhone.charAt(0) === '+' && nationalDigits.indexOf(countryDigits) === 0) {
      nationalDigits = nationalDigits.slice(countryDigits.length);
    }
    nationalDigits = nationalDigits.replace(/^0+/, '');

    var internationalDigits = countryDigits + nationalDigits;
    var phoneIsValid = internationalDigits.length >= 8 && internationalDigits.length <= 15;

    if (phoneNationalInput) {
      phoneNationalInput.setCustomValidity(phoneIsValid ? '' : 'Enter a valid phone number.');
      if (phoneIsValid) {
        phoneNationalInput.removeAttribute('aria-invalid');
      } else {
        phoneNationalInput.setAttribute('aria-invalid', 'true');
      }
    }

    if (phoneInput) phoneInput.value = phoneIsValid ? '+' + internationalDigits : '';
  }

  function handleSubmit(event) {
    if (!form) {
      event.preventDefault();
      return;
    }

    prepareContactFields();
    if (emailInput) emailInput.value = emailInput.value.trim();
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }

    storageSet(window.sessionStorage, PENDING_KEY, 'true');
    if (emailInput) emailInput.removeAttribute('aria-invalid');
    if (errorMessage) errorMessage.hidden = true;
  }

  function handleKeydown(event) {
    if (!isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closePopup(true);
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = focusableElements();

    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  if (closeButton) closeButton.addEventListener('click', function () { closePopup(true); });
  if (continueButton) continueButton.addEventListener('click', function () { closePopup(false); });
  if (launcherOpenButton) launcherOpenButton.addEventListener('click', function () { openPopup(true); });
  if (launcherDismissButton) launcherDismissButton.addEventListener('click', hideLauncher);
  if (backdrop) {
    backdrop.addEventListener('click', function (event) {
      if (event.target === backdrop) closePopup(true);
    });
  }
  if (form) form.addEventListener('submit', handleSubmit);
  if (phoneNationalInput) {
    phoneNationalInput.addEventListener('input', function () {
      phoneNationalInput.setCustomValidity('');
      phoneNationalInput.removeAttribute('aria-invalid');
    });
  }
  if (countryCodeSelect) {
    countryCodeSelect.addEventListener('change', function () {
      if (phoneNationalInput) {
        phoneNationalInput.setCustomValidity('');
        phoneNationalInput.removeAttribute('aria-invalid');
      }
    });
  }
  root.addEventListener('keydown', handleKeydown);

  if (serverSuccess || hasShopifySuccessRedirect()) {
    openPopup(true);
    showSuccess();
    return;
  }

  if (isSubmissionPending()) {
    storageRemove(window.sessionStorage, PENDING_KEY);
    storageSet(window.sessionStorage, DISMISSED_KEY, 'true');
    showLauncher(false);
    return;
  }

  if (serverError) {
    openPopup(true);
    window.setTimeout(showError, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 410);
    return;
  }

  if (window.Shopify && window.Shopify.designMode) return;
  if (isClaimed() || isDismissedForSession()) return;

  function schedulePopup() {
    if (timer !== null) return;
    var delay = parseInt(root.dataset.delay, 10);
    if (isNaN(delay)) delay = 2700;
    timer = window.setTimeout(function () {
      timer = null;
      openPopup(false);
    }, Math.max(2500, delay));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePopup, { once: true });
  } else {
    schedulePopup();
  }
})();
